<template>
  <div>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="current"
      :page-size="pagesDate.pageSize"
      layout="prev, pager, next, jumper"
      :total="pagesDate.total">
    </el-pagination>
  </div>
</template>
<script>
  export default{
    props: ['page','pages'],
    name: 'pagination',
    data(){
      return {
          current:this.pageNum,
          pagesDate:this.pages
      }
    },
    methods:{
      handleCurrentChange(page){
          this.$emit('on-search',page)
      }
    },
    watch:{
      pages(val){
          this.pagesDate = val
      }
    }
  }
</script>
<style>
  .el-pagination__editor.el-input .el-input__inner{
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue